/* Saatdaana product page logic (v11.1): variants, step-by-step pack upsell, shipping bar, gallery, cross-sell, sticky bar */
(function () {
  var S = window.SD;
  if (!S) return;
  function $(id) { return document.getElementById(id); }
  function fmt(n) { try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n); } catch (e) { return 'Rs. ' + n; } }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function toRupees(x) { return typeof x === 'string' ? parseFloat(x) : x / 100; }
  var toastTimer;
  function toast(msg) { var t = $('SdToast'); $('SdToastText').textContent = msg; t.classList.add('is-show'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 3500); }

  /* ===== Variant switching ===== */
  var radios = document.querySelectorAll('#ProductForm .product-option input[type="radio"]');
  var curVariant = null;
  (function () { var id = parseInt($('VariantId').value, 10); S.variants.forEach(function (v) { if (v.id === id) curVariant = v; }); })();
  function currentOptions() { var o = []; radios.forEach(function (r) { if (r.checked) o[parseInt(r.getAttribute('data-option-position'), 10) - 1] = r.value; }); return o; }
  function findVariant(o) { for (var i = 0; i < S.variants.length; i++) { var ok = true; for (var j = 0; j < o.length; j++) { if (S.variants[i].options[j] !== o[j]) { ok = false; break; } } if (ok) return S.variants[i]; } return null; }
  function qty() { var q = document.querySelector('#ProductForm input[name="quantity"]'); return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1; }

  function applyVariant(v) {
    if (!v) return; curVariant = v;
    $('VariantId').value = v.id;
    $('PriceRegular').textContent = v.price;
    var cmp = $('PriceCompare'), save = $('PriceSave');
    cmp.textContent = v.compare; cmp.hidden = !v.hasCompare;
    save.textContent = v.off + '% off'; save.hidden = !v.hasCompare;
    var btn = $('AddBtn'); btn.disabled = !v.available; btn.textContent = v.available ? 'Add to Bag' : 'Sold Out';
    var sb = $('SdStickyBtn'); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to Bag' : 'Sold Out'; $('SdStickyPrice').textContent = v.price; $('SdStickyName').textContent = S.productTitle + (S.variants.length > 1 ? ' (' + v.title + ')' : ''); }
    if (window.history && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    if (v.imageIndex >= 0) setMain(v.imageIndex);
    updateNudge(); updateShip(); renderFbtMain();
  }
  function switchTo(v) { radios.forEach(function (r) { var pos = parseInt(r.getAttribute('data-option-position'), 10) - 1; r.checked = (v.options[pos] === r.value); }); applyVariant(v); }
  radios.forEach(function (r) { r.addEventListener('change', function () { applyVariant(findVariant(currentOptions())); }); });
  var qEl = document.querySelector('#ProductForm input[name="quantity"]');
  document.querySelectorAll('#ProductForm .quantity-btn').forEach(function (b) { b.addEventListener('click', function () { setTimeout(function () { updateShip(); renderFbtMain(); }, 0); }); });
  if (qEl) qEl.addEventListener('change', function () { updateShip(); renderFbtMain(); });

  /* ===== Step-by-step pack-size upsell (real prices, prices are never changed) =====
     Suggests only the NEXT size up (200 g > 400 g > 800 g > 1 kg), never a jump to the biggest pack.
     If the next size is cheaper per 100 g, the saving is shown. If not, only the extra weight is shown (no saving claim).
     Weight = the LAST "number + g/kg" in the variant title, so "2 x 200 g (400 g)" counts as 400 g. */
  function grams(v) {
    var re = /([\d.]+)\s*(kg|g)\b/ig, m, last = null;
    while ((m = re.exec(v.title)) !== null) last = m;
    if (!last) return 0;
    return parseFloat(last[1]) * (last[2].toLowerCase() === 'kg' ? 1000 : 1);
  }
  function wt(g) { return g >= 1000 ? (Math.round(g / 10) / 100) + ' kg' : g + ' g'; }
  function updateNudge() {
    var box = $('SdNudge'); if (!box || !curVariant) return;
    var curG = grams(curVariant); if (!curG) { box.hidden = true; return; }
    var next = null, nextG = 0;
    S.variants.forEach(function (v) { var g = grams(v); if (g > curG && (!next || g < nextG)) { next = v; nextG = g; } });
    if (!next || !next.available) { box.hidden = true; return; }
    var extra = next.priceNum - curVariant.priceNum;
    if (extra <= 0) { box.hidden = true; return; }
    var curPer = curVariant.priceNum / curG * 100, nextPer = next.priceNum / nextG * 100;
    var saved = curPer * nextG / 100 - next.priceNum;
    var r1 = function (n) { return Math.round(n * 10) / 10; };
    var html = 'Add just <strong>' + esc(fmt(Math.round(extra))) + '</strong> more for <strong>' + esc(next.title) + '</strong>. ';
    if (saved >= 1) html += 'You pay ' + esc(fmt(r1(nextPer))) + ' per 100 g instead of ' + esc(fmt(r1(curPer))) + ', saving ' + esc(fmt(Math.round(saved))) + '.';
    else html += 'That is ' + esc(wt(nextG - curG)) + ' more in your pack.';
    $('SdNudgeText').innerHTML = html;
    var nb = $('SdNudgeBtn'); nb.textContent = 'Upgrade to ' + next.title; nb.onclick = function () { switchTo(next); };
    box.hidden = false;
  }

  /* ===== Free shipping progress (only if threshold set in theme editor) ===== */
  var cartTotal = 0;
  function updateShip() {
    var el = $('SdShip'); if (!el || !S.freeShip || !curVariant) return;
    var total = cartTotal + curVariant.priceNum * qty(), left = S.freeShip - total;
    $('SdShipText').textContent = left > 0 ? 'Add ' + fmt(Math.ceil(left)) + ' more to get free shipping' : 'You have unlocked free shipping';
    $('SdShipFill').style.width = Math.min(100, Math.round(total / S.freeShip * 100)) + '%';
    el.hidden = false;
  }
  function loadCart() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price / 100; updateShip(); }).catch(function () {}); }

  /* ===== Gallery ===== */
  var mainImg = $('PgMainImg'), thumbs = document.querySelectorAll('.pg-thumb'), activeIndex = 0;
  function setMain(i) { if (!S.images[i] || !mainImg) return; activeIndex = i; mainImg.src = S.images[i].small; mainImg.alt = S.images[i].alt; thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(parseInt(t.getAttribute('data-index'), 10)); }); });
  var mainBtn = $('PgMainBtn');
  window.SDX = { setMain: setMain, getActive: function () { return activeIndex; }, mainBtn: mainBtn };
  if (mainBtn && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    mainBtn.addEventListener('mousemove', function (e) { var r = mainBtn.getBoundingClientRect(); mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; mainImg.style.transform = 'scale(1.8)'; });
    mainBtn.addEventListener('mouseleave', function () { mainImg.style.transform = 'scale(1)'; });
  }

  /* ===== Cross-sell: frequently bought together ===== */
  var fbt = $('SdFbt'), recs = [];
  function renderFbtMain() { if (fbt && !fbt.hidden) renderFbt(); }
  function pickVariant(p) { var vs = p.variants || []; for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i]; return null; }
  function imgUrl(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function renderFbt() {
    var row = $('SdFbtRow'), html = '', total = 0, n = 0;
    var q = qty();
    var mainImgUrl = S.images.length ? S.images[0].small : '';
    html += '<div class="sd-fbt__item">' + (mainImgUrl ? '<img class="sd-fbt__img" src="' + esc(mainImgUrl) + '" alt="" loading="lazy">' : '<div class="sd-fbt__ph">S</div>') + '<span class="sd-fbt__meta">This item</span><span class="sd-fbt__name">' + esc(S.productTitle) + (S.variants.length > 1 ? ' (' + esc(curVariant.title) + ')' : '') + '</span><span class="sd-fbt__price">' + esc(curVariant.price) + (q > 1 ? ' x ' + q : '') + '</span></div>';
    total += curVariant.priceNum * q; n += q;
    recs.forEach(function (r, i) {
      var v = r.v, on = r.on;
      html += '<span class="sd-fbt__plus" aria-hidden="true">+</span><div class="sd-fbt__item' + (on ? '' : ' is-off') + '">' +
        (r.p.featured_image ? '<img class="sd-fbt__img" src="' + esc(imgUrl(r.p.featured_image, 400)) + '" alt="' + esc(r.p.title) + '" loading="lazy">' : '<div class="sd-fbt__ph">S</div>') +
        '<a class="sd-fbt__name" href="' + esc(r.p.url) + '">' + esc(r.p.title) + '</a>' +
        '<span class="sd-fbt__meta">' + esc(v.title && v.title !== 'Default Title' ? v.title : '') + '</span>' +
        '<span class="sd-fbt__price">' + esc(fmt(toRupees(v.price))) + '</span>' +
        '<label class="sd-fbt__chk"><input type="checkbox" data-rec="' + i + '"' + (on ? ' checked' : '') + '> Add to order</label></div>';
      if (on) { total += toRupees(v.price); n += 1; }
    });
    row.innerHTML = html;
    $('SdFbtTotal').textContent = 'Total ' + fmt(total);
    $('SdFbtCount').textContent = n + ' item' + (n > 1 ? 's' : '') + ' selected';
    var add = $('SdFbtAdd'); add.disabled = !curVariant.available; add.textContent = 'Add ' + (recs.some(function (r) { return r.on; }) ? 'all selected' : 'this item') + ' to bag';
    row.querySelectorAll('input[data-rec]').forEach(function (c) { c.addEventListener('change', function () { recs[parseInt(c.getAttribute('data-rec'), 10)].on = c.checked; renderFbt(); }); });
  }
  function loadFbt() {
    if (!fbt) return;
    fetch('/recommendations/products.json?product_id=' + S.productId + '&limit=6&intent=related').then(function (r) { return r.json(); }).then(function (d) {
      var list = (d.products || []).filter(function (p) { return pickVariant(p); }).slice(0, S.crossSellMax || 2);
      recs = list.map(function (p) { return { p: p, v: pickVariant(p), on: true }; });
      if (!recs.length) return;
      fbt.hidden = false; renderFbt();
    }).catch(function () {});
  }
  var fbtAdd = $('SdFbtAdd');
  if (fbtAdd) fbtAdd.addEventListener('click', function () {
    var items = [{ id: curVariant.id, quantity: qty() }];
    recs.forEach(function (r) { if (r.on) items.push({ id: r.v.id, quantity: 1 }); });
    fbtAdd.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { toast(items.length + ' item' + (items.length > 1 ? 's' : '') + ' added to your bag'); loadCart(); })
      .catch(function () { toast('Could not add. Please try again.'); })
      .then(function () { fbtAdd.disabled = !curVariant.available; });
  });

  /* ===== Sticky add to bag (mobile) ===== */
  var sticky = $('SdSticky'), addBtn = $('AddBtn');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 }).observe(addBtn);
    $('SdStickyBtn').addEventListener('click', function () { var f = $('ProductForm'); if (f.requestSubmit) f.requestSubmit(); else f.submit(); });
  }

  updateNudge(); loadCart(); loadFbt();
})();